/* eslint-disable */
import axios from 'axios';
import { API_URL } from '@/common/config';
import Swal from 'sweetalert2';
import moment from 'moment';

export function showSimpleMessage(title, text, icon = 'info', timer = 1500) {
  Swal.fire({
    icon,
    title,
    text,
    showConfirmButton: false,
    timer,
    timerProgressBar: 'my-progress-bar',
  });
}
export async function showConfirmacionMessage(
  title = '¿Desea confirmar?',
  text = '',
  icon = 'warning',
  showCancelButton = true
) {
  // icon="info", 'warning', 'success', 'danger'
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton,
    confirmButtonText: 'Si',
    cancelButtonText: 'No, Cancelar',
    showCloseButton: true,
    showLoaderOnConfirm: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      return true;
    }
    return false;
  });
}

export function formatDateUnix(d) {
  // Validar si es un número válido
  if (isNaN(d) || d === null || d === undefined) {
    return 'Fecha inválida'; // Opcional: Puedes devolver una cadena vacía o un mensaje de error
  }

  // Asegurarse de que sea un timestamp en segundos
  const timestamp = typeof d === 'number' ? d / 1000 : d;

  // Formatear la fecha
  const momentObject = moment.unix(d / 1000);
  const formattedDate = momentObject.format('DD/MM/YYYY');
  if (d === 1742586010896) {
    console.log(formattedDate);
  }

  return formattedDate;
}
export function formatDate(d) {
  const date = new Date(d);
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  return (d = dd + '/' + mm + '/' + yyyy);
}
export async function getCodJerarquia(nombreOperatoria) {
  try {
    if (!nombreOperatoria) return;
    const url = `${API_URL}api/trilay/codjerarquia?nombreOperatoria=${nombreOperatoria}`;
    const header = {
      headers: {
        token: localStorage.getItem('token'),
      },
    };

    return await axios
      .get(url, header)
      .then((r) => {
        if (r.data.status === 'success') {
          return {
            codjerarquia: r.data.codJerarquia,
            codGastos: r.data.codGastos,
          };
        }
        return false;
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
  } catch (e) {
    console.error(e);
  }
}
function getEstadoTrilayId(estado_id) {
  let res;
  switch (estado_id) {
    case 7:
      res = 1;
      break;
    default:
      res = 1;
      break;
  }
  return res;
}
function getFechaInicio(cm) {
  return Object.keys(cm)[0].replace(/-/g, '/');
}
function getFechaUltimaCuota(cm) {
  const last = Object.keys(cm).length - 1;
  return Object.keys(cm)[last].replace(/-/g, '/');
}
function getTotales(cm, campo) {
  const sum = Object.values(cm).reduce((accumulator, object) => {
    return accumulator + Number.parseFloat(object[campo]);
  }, 0);
  return sum;
}

function roundArray(cuadro) {
  if (cuadro) {
    //hago un redondeo de los valores del cuadro marcha
    const formattedData = Object.fromEntries(
      Object.entries(cuadro).map(([key, value]) => {
        const formattedValues = {
          ...value,
          Saldo_Inicial: +value.Saldo_Inicial.toFixed(2),
          Amortizacion: +value.Amortizacion.toFixed(2),
          Intereses: +value.Intereses.toFixed(2),
          Saldo_Final: +value.Saldo_Final.toFixed(2),
          IVA_Intereses: +value.IVA_Intereses.toFixed(2),
          Cuota: +value.Cuota.toFixed(2),
          Cuota_Total: +value.Cuota_Total.toFixed(2),
        };
        return [key, formattedValues];
      })
    );
    return formattedData;
  }
}

function buildGastosString(codGastos, item) {
  if (!codGastos || !Array.isArray(codGastos) || codGastos.length === 0) {
    return '';
  }

  const monto_desembolso = Math.round(
    parseFloat(item.params.monto.replace(',', '.'))
  );

  return codGastos
    .map((gasto) => {
      const impuesto = 0.0;
      const baseCalculo = 0;
      const gast_admin_iibb =
        Number.parseFloat(item.gasto_admin) + Number.parseFloat(item.iibb);
      const gastos_otorga = Number.parseFloat(item.gasto_otorga);

      if (gasto.gasto === 'Otorgamiento') {
        return `${
          gasto.codgasto
        },${baseCalculo},${gastos_otorga},${impuesto.toFixed(
          2
        )},${gastos_otorga},${impuesto.toFixed(2)}`;
      }
      if (gasto.gasto === 'Administrativos') {
        return `${gasto.codgasto},${baseCalculo},${gast_admin_iibb.toFixed(
          2
        )},${impuesto.toFixed(2)},${gast_admin_iibb.toFixed(
          2
        )},${impuesto.toFixed(2)}`;
      }
      if (gasto.gasto === 'Honorarios MF') {
        return `${gasto.codgasto},${baseCalculo},${impuesto.toFixed(
          2
        )},${impuesto.toFixed(2)},${impuesto.toFixed(2)},${impuesto.toFixed(
          2
        )}`;
      }
    })
    .filter(Boolean)
    .join('|');
}

export async function convertToModuloCredito(items) {
  try {
    const item = items;
    if (!item.cliente.cuit) {
      console.log('error', 'El CUIT/CUIL es obligatorio.');
      return {
        error: true,
        title: 'Error de validación',
        message: 'El CUIT/CUIL es obligatorio.',
      };
    }
    const { codjerarquia, codGastos } = await getCodJerarquia(
      item.tipo_operatoria
    );
    const gast_admin_iibb =
      Number.parseFloat(item.gasto_admin) + Number.parseFloat(item.iibb);
    const gastos_otorga = item.gasto_otorga.toFixed(2);

    const {
      nombre,
      apellido,
      domicilioReal: domicilio,
      cuit: nrodoc,
      celular: tel,
      mail: mail,
    } = item.cliente;

    return {
      cliente: {
        razonsocial: `${apellido} ${nombre}`,
        nrodoc,
        tel,
        mail,
        codjerarquia,
        fecha: new Date().toLocaleDateString('en-GB').toString(),
        domicilio,
      },
      codjerarquia,
      coddestino: 2,
      codcliente: item.lineacreditocliente[0].codigo_cliente_trilay,
      fecha_solicitud: formatDate(item.lineacreditocliente[0].createdAt),
      fecha_inicio: getFechaInicio(item.cuadro),
      fecha_ultima_cuota: getFechaUltimaCuota(item.cuadro),
      fecha_desembolso: item.lineacreditocliente[0].fecha_desembolso,
      cant: 1, // ciclo
      id: item.lineacreditocliente[0].id,
      estado_id: getEstadoTrilayId(item.lineacreditocliente[0].estado_id),
      fecha_nac: '',
      edad_solic: 0,
      operatoria: item.tipo_operatoria,
      nrodoc: item.cliente.cuit,
      monto_total: item.liquidacion.total,
      coeficiente_int_moratorio: 0.11,
      monto_desembolso: Math.round(
        parseFloat(item.params.monto.replace(',', '.'))
      ),
      frecuencia: item.params.periodicidad_pagos,
      tipo_amortizacion: 1,
      plazo: item.params.plazo_credito / item.params.periodicidad_pagos,
      taza: item.tasa,
      perdiodo_gracia: item.params.periodo_gracia,
      gastos: buildGastosString(codGastos, item),
      cuadro_marcha: item.cuadro,
      monto_total_intereses: Math.floor(
        Number(getTotales(item.cuadro, 'Intereses'))
      ),

      monto_capital_devolver: Math.floor(
        Number(getTotales(item.cuadro, 'Cuota_Total'))
      ),
    };
  } catch (e) {
    console.log(e);
    return 'error';
  }
}

export async function redireccion() {
  try {
    const token = localStorage.getItem('token');

    if (token !== null && token !== '') {
      const timeout = 3000; // 3 segundos
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);

      const response = await axios.post(
        `${API_URL}api/v1/auth/validarToken`,
        {},
        {
          headers: {
            token: token,
          },
        }
      );
      clearTimeout(timeoutId);
      // Verificar si la respuesta es OK (status 200)
      if (response.data.status === 'success') {
        return true; // Token válido
      }
    }
    // Si no hay token o el token no es válido, redirige al login
    localStorage.removeItem('token');
    localStorage.clear();
    return false;
  } catch (error) {
    console.error('Error en redireccion:', error);
    // Manejar errores específicos, por ejemplo:
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.clear();
    }
    return false; // Regresa false en caso de error
  }
}

export function formatMonto(
  numero,
  locale = 'es-AR',
  opciones = { style: 'currency', currency: 'ARS' }
) {
  // Creamos un formateador de números con las opciones especificadas
  const formatter = new Intl.NumberFormat(locale, opciones);

  // Formateamos el número y retornamos la cadena resultante
  return formatter.format(numero).replace('$', '');
}
